module.exports = __webpack_public_path__ + "static/img/3.2f474b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/3.png
// module id = 2Ujj
// module chunks = 1